import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { DealerLocatorSegment } from "@swo/storefront";
import React from "react";

import { css } from "@emotion/react";

import { CSS_COLORS, CSS_SPACER_SIZES } from "../../../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../../../styles/breakpoints";
import { SwarovskiRadio } from "../../../../../components/_shared-components/ui-elements/SwarovskiRadio";
import { SegmentIconSvg } from "../../../../../components/DealerLocatorComponent/subcomponents/segment-icons";
import { DealerDto } from "@swo/salesforce-service";

export const SegmentSelector: ReactTFC<{
  segments: Array<{ name: NonNullable<DealerDto["segment"]>; label: string; checked: boolean }>;
  setSegments: React.Dispatch<
    React.SetStateAction<Array<{ name: NonNullable<DealerDto["segment"]>; label: string; checked: boolean }>>
  >;
}> = props => {
  return (
    <div css={topWrapperStyles}>
      {props.segments.map(segment => {
        return (
          <div key={segment.name} className={segment.checked ? "selected" : "not-selected"} css={wrapperStyles}>
            <SwarovskiRadio
              customColorInput={undefined}
              labelProps={{
                className: segment.name,
              }}
              inputProps={{
                value: segment.name,
                disabled: false,
                checked: segment.checked,
                onChange: () =>
                  props.setSegments(segments =>
                    segments.map(s => {
                      if (s.name === segment.name) {
                        return { ...s, checked: !s.checked };
                      } else {
                        return s;
                      }
                    }),
                  ),
                name: "segment",
              }}
              type={"checkbox"}
              attachStyles={css`
                display: flex;
                align-items: flex-end;

                ${CSS_MQ.atMostSm} {
                  align-items: center;
                  width: 100%;
                }
              `}
            >
              <div
                css={css`
                  display: flex;

                  ${CSS_MQ.atMostSm} {
                    align-items: center;
                  }

                  ${CSS_MQ.atLeastMd} {
                    flex-direction: column;
                    align-items: center;
                  }
                `}
              >
                <SegmentIconSvg segment={segment.name} cropped={true} css={iconStyles} />
                <span css={labelStyles}>{segment.label}</span>
              </div>
            </SwarovskiRadio>
          </div>
        );
      })}
    </div>
  );
};

const topWrapperStyles = css`
  width: 100%;
  margin-bottom: 70px;
  ${CSS_MQ.atMostSm} {
    margin-bottom: 50px;
  }

  display: flex;
  justify-content: space-between;

  ${CSS_MQ.atMostSm} {
    flex-direction: column;
  }
`;

const iconStyles = css`
  ${CSS_MQ.atMostSm} {
    width: 45px;
    height: 45px;
    margin-right: 15px;
  }

  ${CSS_MQ.atLeastMd} {
    width: 75px;
    height: 75px;
    margin-bottom: 10px;
  }

  stroke-width: 1.2;
  color: ${CSS_COLORS.Green};
`;

const labelStyles = css`
  text-transform: uppercase;
  font-weight: 500;

  ${CSS_MQ.atMostSm} {
    display: flex;
    align-items: flex-end;
  }
`;

const wrapperStyles = css`
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${CSS_MQ.atMostSm} {
    align-items: flex-start;
  }

  &.selected {
    color: ${CSS_COLORS.Green};
  }

  &.not-selected {
    color: ${CSS_COLORS.Black};
  }
`;
